<template>
  <div class="rentalPayouts">
    <h4>Mes paiements</h4>

    <div class="rentalPayouts__table">
      <div class="rentalPayouts__table-heading">
        <div class="rentalPayouts__table-heading-date">
          Date
        </div>
        <div class="rentalPayouts__table-heading-denominated">
          Libellés
        </div>
        <div class="rentalPayouts__table-heading-amount">
          Montant
        </div>
        <div class="rentalPayouts__table-heading-status">
          &nbsp;
        </div>
      </div>

      <div class="rentalPayouts__table-item">
        <div class="rentalPayouts__table-item-date">
          30/11/2019
        </div>
        <div class="rentalPayouts__table-item-denominated">
          Loyer + charge + divers
        </div>
        <div class="rentalPayouts__table-item-amount">
          537,07 €
        </div>
        <div class="rentalPayouts__table-item-status">
          somme à régler
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RentalPayouts'
}
</script>

<style lang="scss" scoped>
$c: '.rentalPayouts';

#{$c} {
  border-top: solid 1px #e4e7ed;
  padding-top: 32px;
  padding-bottom: 32px;

  &__table {
    margin-top: 24px;
    display: flex;
    flex-direction: column;
    width: 100%;

    & > div {
      display: flex;
      width: 100%;
      justify-content: space-between;
      border-bottom: solid 1px #e4e7ed;
      font-size: 14px;

      & > div {
        &:first-child {
          flex: 15% 0;
        }

        &:nth-child(2) {
          flex: 35% 0;
        }

        &:nth-child(3) {
          flex: 25% 0;
        }

        &:nth-child(4) {
          flex: 30% 0;
        }
      }
    }

    &-heading {
      padding-top: 24px;
      padding-bottom: 24px;
      color: #909399;
    }

    &-item {
      padding-top: 24px;
      padding-bottom: 24px;
      align-items: center;
      color: #606266;

      &-amount {
        color: $--color-primary;
      }
    }
  }
}
</style>